import { WebsitePostCategoryDTO, WebsiteContentLinkDTO } from 'src/services/generated/api.generated.v1';
import {FAQ, Podcast, Post} from '../../components/models';

export interface ConsumerInformationInterface {
    contentLinks: WebsiteContentLinkDTO | null;
    allPosts: Array<Post> | null; 
    postCategories: Array<WebsitePostCategoryDTO> | null;
    frequentlyAskedQuestions: FAQ | null; 
    podcasts: Array<Podcast> | null; 
}

function state(): ConsumerInformationInterface {
    return {
        contentLinks: null,
        allPosts: null,
        postCategories: null,
        frequentlyAskedQuestions: null,
        podcasts: null
    }
}

export default state;